<template>
	<Modal
		v-if="showModal"
		:allow-close="true"
		:max-width="'max-w-[691px]'"
		:hide-actions="true"
		@modal:close="closeModal(false)"
	>
		<template #body>
			<div class="pb-[50px]">
				<div class="my-10 flex items-center justify-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="110"
						height="80"
						viewBox="0 0 110 80"
						fill="none"
					>
						<path
							d="M94.794 39.9327C94.794 60.33 78.2587 76.8653 57.8614 76.8653C37.464 76.8653 20.9287 60.33 20.9287 39.9327C20.9287 19.5353 37.464 3 57.8614 3C67.0264 3 75.4117 6.33834 81.8676 11.8654C89.7798 18.6391 94.794 28.7003 94.794 39.9327Z"
							fill="#FFDBDB"
						/>
						<circle
							cx="103.412"
							cy="9.15544"
							r="6.15544"
							fill="#FFDBDB"
						/>
						<circle
							cx="3.69327"
							cy="38.6996"
							r="3.69327"
							fill="#FF5F5F"
						/>
						<path
							d="M53.1326 73.0798C74.0487 73.0798 91.0046 56.1258 91.0046 35.2119C91.0046 29.4131 89.701 23.9187 87.3709 19.0057C92.0262 25.0691 94.7933 32.6576 94.7933 40.8924C94.7933 60.7605 78.6852 76.8669 58.8149 76.8669C50.5821 76.8669 42.9951 74.1019 36.9321 69.4501C41.8437 71.7777 47.3361 73.0798 53.1326 73.0798Z"
							fill="white"
						/>
						<path
							d="M43.0778 6.07772C47.6045 4.09821 52.6047 3 57.8614 3C67.0264 3 75.4117 6.33834 81.8676 11.8654C89.7798 18.6391 94.794 28.7003 94.794 39.9327C94.794 49.9505 90.8055 59.0368 84.3298 65.6901C77.6203 72.5836 68.2409 76.8653 57.8614 76.8653C37.464 76.8653 20.9287 60.33 20.9287 39.9327C20.9287 32.7892 22.9568 26.1193 26.4686 20.4676"
							stroke="#FF5F5F"
							stroke-width="5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M46.3735 27.4667L66.4942 48.4107"
							stroke="#FF5F5F"
							stroke-width="6"
							stroke-linecap="round"
						/>
						<path
							d="M66.4941 27.4667L46.3735 48.4107"
							stroke="#FF5F5F"
							stroke-width="6"
							stroke-linecap="round"
						/>
					</svg>
				</div>
				<div class="mb-15 text-won-blue">
					<h2 class="text-center text-[24px] leading-[34px] font-semibold">{{ title }}</h2>
					<p
						class="mt-4 mb-6 text-center"
					>
						Your subscription will remain active until {{ activeUntil }}. Thank you for your feedback— we'll use it to improve our service!
					</p>
				</div>

				<div class="mt-12 flex items-center justify-center">
					<button
						class="w-[480px] rounded bg-won-green p-[9.5px] text-base text-white"
						@click="handleReactivate"
					>
						<template v-if="isReactivating">
							<LoadingIcon />
						</template>
						<template v-else>
							Change your mind? Reactivate subscription
						</template>
					</button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup>

import { ref } from 'vue';
import Modal from '../../modal';
import LoadingIcon from '../../../icons/loading-spinner.vue';

const title = ref('You have cancelled your premium plan');

const emit = defineEmits(['reactivate-subscription']);

defineProps({
	showModal: {
		type: Boolean,
		default: false,
	},
	closeModal: {
		type: Function,
		required: true
	},
	activeUntil: {
		type: String,
		default: null
	},
	isReactivating: {
		type: Boolean,
		default: false
	}
});

const handleReactivate = () => {
	emit('reactivate-subscription');
};
</script>


